"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.date_validations = void 0;
var _luxon = require("luxon");
const numbers_as_str = Array.from({
  length: 10
}).map((_v, i) => String(i));
const date_validations = exports.date_validations = {
  'DD/MM/YYYY': function (value, i) {
    const char = value[i];
    if (value === '0') return true;
    let day = parseInt(value.slice(0, 2)),
      month = parseInt(value.slice(3, 5));
    let year = parseInt(value.slice(6, 10));
    if (i === 0 || i === 1)
      // DD
      {
        let max_day = 31,
          smart_set;
        if (!isNaN(month)) {
          smart_set ||= {};
          smart_set.month = month;
        }
        if (!isNaN(year)) {
          smart_set ||= {};
          smart_set.year = year;
        }
        if (smart_set) {
          let date = _luxon.DateTime.now().set(smart_set);
          if (date.isValid) {
            max_day = parseInt(date.endOf('month').toFormat('dd'));
          }
        }
        if (day < 1 || day > max_day) return false;
        if (i === 0) {
          return ['0', '1', '2', '3'].includes(char);
        } else if (i === 1) {
          return numbers_as_str.includes(char);
        }
      }
    if (i === 3 || i === 4)
      // MM
      {
        if (month < 1 || month > 12) return false;
        if (i === 3) {
          return ['0', '1'].includes(char);
        }
        if (i === 4) {
          return numbers_as_str.includes(char);
        }
      }
    if (i > 5)
      // YYYY
      {
        return numbers_as_str.includes(char);
      }
    return true;
  },
  'YYYY': function (value, i) {
    const char = value[i];
    return numbers_as_str.includes(char);
  }
};
